// Criteria the user expressed in natural language, whether in Copilot or in
// AI Filters. Criteria added through the graphical controls are not AI ones.
export const AI_CRITERIA_SOURCES = ['one_shot', 'ai_filter'];

export function isAiCriteriaSource(source) {
  return AI_CRITERIA_SOURCES.includes(source);
}
